import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Store, User, Phone, MapPin, ReceiptText } from "lucide-react";
import { api } from "@/lib/api";

export default function CentresAdmin() {
  const [type, setType] = useState("");
  const { data: profiles = [], isLoading } = useQuery({
    queryKey: ["admin-billing-profiles", type],
    queryFn: () => api.adminBillingProfiles(type),
  });

  const tabs = [
    { id: "", label: "All" },
    { id: "centre", label: "Centres" },
    { id: "direct_seller", label: "Direct Sellers" },
  ];

  return (
    <div>
      <h2 className="font-display text-2xl text-ink mb-1">Registered Centres & Sellers</h2>
      <p className="text-xs text-muted2 mb-4">Altos ID holders who registered to use retail billing.</p>

      <div className="flex gap-2 mb-5">
        {tabs.map((t) => (
          <button key={t.id} onClick={() => setType(t.id)} data-testid={`centre-filter-${t.id || "all"}`}
            className={`h-9 px-4 rounded-full text-sm font-semibold border transition-colors ${type === t.id ? "bg-brand text-white border-brand" : "bg-paper text-ink border-line hover:border-brand"}`}>
            {t.label}
          </button>
        ))}
      </div>

      {isLoading ? (
        <p className="text-muted2">Loading…</p>
      ) : profiles.length === 0 ? (
        <p className="text-muted2 py-8 text-center border border-dashed border-line rounded-xl" data-testid="centres-empty">No registrations yet.</p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3" data-testid="centres-list">
          {profiles.map((p) => (
            <div key={p.altos_id} className="rounded-xl border border-line p-4" data-testid={`centre-${p.altos_id}`}>
              <div className="flex items-start justify-between gap-2">
                <div className="flex items-center gap-2">
                  {p.type === "centre" ? <Store className="text-brand" size={18} /> : <User className="text-brand" size={18} />}
                  <div>
                    <p className="font-semibold text-ink">{p.name}</p>
                    <p className="text-xs text-muted2">{p.type === "centre" ? "Centre" : "Direct Seller"}{p.centre_id ? ` · ID ${p.centre_id}` : ""}</p>
                  </div>
                </div>
                <span className="text-xs font-semibold text-brand flex items-center gap-1"><ReceiptText size={13} /> {p.bill_count} bills</span>
              </div>
              <div className="mt-3 space-y-1 text-sm text-ink/80">
                <p className="flex items-center gap-2"><Phone size={13} className="text-muted2" /> {p.mobile}</p>
                {p.address && <p className="flex items-start gap-2"><MapPin size={13} className="text-muted2 mt-0.5 shrink-0" /> {p.address}</p>}
                <p className="text-xs text-muted2">Altos ID: {p.altos_id}{p.altos_name ? ` (${p.altos_name})` : ""}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
